import {
  CAMPAIGN_VIEW_REQUEST,
  CAMPAIGN_VIEW_FAIL,
  CAMPAIGN_VIEW_SUCCESS,
  CATEGORY_VIEW_REQUEST,
  CATEGORY_VIEW_FAIL,
  CATEGORY_VIEW_SUCCESS,
  TEAM_VIEW_REQUEST,
  TEAM_VIEW_FAIL,
  TEAM_VIEW_SUCCESS,
  PARTNER_VIEW_REQUEST,
  PARTNER_VIEW_FAIL,
  PARTNER_VIEW_SUCCESS,
  STORY_VIEW_SUCCESS,
  STORY_VIEW_REQUEST,
  STORY_VIEW_FAIL,
  CONTENT_VIEW_SUCCESS,
  CONTENT_VIEW_REQUEST,
  CONTENT_VIEW_FAIL,
  ADVISORY_VIEW_REQUEST,
  ADVISORY_VIEW_FAIL,
  ADVISORY_VIEW_SUCCESS,
  LANG_VIEW_REQUEST,
  LANG_VIEW_FAIL,
  LANG_VIEW_SUCCESS,
  CONTACT_VIEW_REQUEST,
  CONTACT_VIEW_FAIL,
  CONTACT_VIEW_SUCCESS,
  ADMIN_VIEW_REQUEST,
  ADMIN_VIEW_FAIL,
  ADMIN_VIEW_SUCCESS,
  TRANSACTION_VIEW_SUCCESS,
  TRANSACTION_VIEW_FAIL,
  TRANSACTION_VIEW_REQUEST,
  PARTNER_CONTACT_VIEW_REQUEST,
  PARTNER_CONTACT_VIEW_FAIL,
  PARTNER_CONTACT_VIEW_SUCCESS,
  FEATURE_VIEW_REQUEST,
  FEATURE_VIEW_FAIL,
  FEATURE_VIEW_SUCCESS,
  FAQ_VIEW_REQUEST,
  FAQ_VIEW_FAIL,
  FAQ_VIEW_SUCCESS,
} from "../constants/campaignConstants";

export const campaignViewReducer = (state = {}, action) => {
  switch (action.type) {
    case CAMPAIGN_VIEW_REQUEST:
      return { loading: true };
    case CAMPAIGN_VIEW_SUCCESS:
      return { loading: false, campaign: action.payload };
    case CAMPAIGN_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const categoryViewReducer = (state = {}, action) => {
  switch (action.type) {
    case CATEGORY_VIEW_REQUEST:
      return { loading: true };
    case CATEGORY_VIEW_SUCCESS:
      return { loading: false, category: action.payload };
    case CATEGORY_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const teamViewReducer = (state = {}, action) => {
  switch (action.type) {
    case TEAM_VIEW_REQUEST:
      return { loading: true };
    case TEAM_VIEW_SUCCESS:
      return { loading: false, team: action.payload };
    case TEAM_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const featureViewReducer = (state = {}, action) => {
  switch (action.type) {
    case FEATURE_VIEW_REQUEST:
      return { loading: true };
    case FEATURE_VIEW_SUCCESS:
      return { loading: false, feature: action.payload };
    case FEATURE_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const partnerViewReducer = (state = {}, action) => {
  switch (action.type) {
    case PARTNER_VIEW_REQUEST:
      return { loading: true };
    case PARTNER_VIEW_SUCCESS:
      return { loading: false, partner: action.payload };
    case PARTNER_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const storyViewReducer = (state = {}, action) => {
  switch (action.type) {
    case STORY_VIEW_REQUEST:
      return { loading: true };
    case STORY_VIEW_SUCCESS:
      return { loading: false, story: action.payload };
    case STORY_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const contentViewReducer = (state = {}, action) => {
  switch (action.type) {
    case CONTENT_VIEW_REQUEST:
      return { loading: true };
    case CONTENT_VIEW_SUCCESS:
      return { loading: false, content: action.payload };
    case CONTENT_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const advisoryViewReducer = (state = {}, action) => {
  switch (action.type) {
    case ADVISORY_VIEW_REQUEST:
      return { loading: true };
    case ADVISORY_VIEW_SUCCESS:
      return { loading: false, advisory: action.payload };
    case ADVISORY_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const languageViewReducer = (state = {}, action) => {
  switch (action.type) {
    case LANG_VIEW_REQUEST:
      return { loading: true };
    case LANG_VIEW_SUCCESS:
      return { loading: false, language: action.payload };
    case LANG_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const contactViewReducer = (state = {}, action) => {
  switch (action.type) {
    case CONTACT_VIEW_REQUEST:
      return { loading: true };
    case CONTACT_VIEW_SUCCESS:
      return { loading: false, contact: action.payload };
    case CONTACT_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const adminViewReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_VIEW_REQUEST:
      return { loading: true };
    case ADMIN_VIEW_SUCCESS:
      return { loading: false, adminDetails: action.payload };
    case ADMIN_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const transactionViewReducer = (state = {}, action) => {
  switch (action.type) {
    case TRANSACTION_VIEW_REQUEST:
      return { loading: true };
    case TRANSACTION_VIEW_SUCCESS:
      return { loading: false, transactionDetails: action.payload };
    case TRANSACTION_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const partnerscontactViewReducer = (state = {}, action) => {
  switch (action.type) {
    case PARTNER_CONTACT_VIEW_REQUEST:
      return { loading: true };
    case PARTNER_CONTACT_VIEW_SUCCESS:
      return { loading: false, contactPartner: action.payload };
    case PARTNER_CONTACT_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const faqViewReducer = (state = {}, action) => {
  switch (action.type) {
    case FAQ_VIEW_REQUEST:
      return { loading: true };
    case FAQ_VIEW_SUCCESS:
      return { loading: false, faq: action.payload };
    case FAQ_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
